import React, { PropsWithChildren } from 'react';

export const AuthTemplateCentralizedContainer = ({
  children,
}: PropsWithChildren) => (
  <div className="auth-template-centralized-container">
    {children}

    <style jsx>{`
      .auth-template-centralized-container {
        padding: 20px;
        max-width: 390px;
        width: 390px;
        margin: auto;
      }
    `}</style>
  </div>
);
